import React, {MouseEvent} from 'react';
import styled from 'styled-components';
import Tooltip from '@material-ui/core/Tooltip';
import {withStyles, Theme} from '@material-ui/core/styles';
import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';

const StyledCellContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;

const StyledHelpOutlineRoundedIcon = styled(HelpOutlineRoundedIcon)`
  color: ${props => props.theme.tableText};
  font-size: 1rem;
  flex-shrink: 0;
`;

const StyledCellText = styled.div<{$textWidth?: string}>`
  flex: 1;
  min-width: 0;
  max-width: ${props => props.$textWidth || 'none'};
  font-size: 16px;
  line-height: 1.2;
  font-family: 'Trade Gothic Bold Condensed';
  color: ${props => props.theme.tableText};
  text-transform: uppercase;
  white-space: normal;
  word-break: normal;
  overflow-wrap: normal;
`;

const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0)',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
  arrow: {
    color: '#f5f5f9',
  },
}))(Tooltip);

const inhibitClick = (event: MouseEvent<HTMLHeadingElement>) => {
  event.stopPropagation();
  event.preventDefault();
};

interface TableToolTipCellProps {
  value: string;
  tooltip: string;
  /** Optional cap on label width; label flex-shrinks below this when the column is narrow so the help icon stays visible. */
  textWidth?: string;
}

export default function TableToolTipCell({value, tooltip, textWidth}: TableToolTipCellProps) {
  return (
    <StyledCellContainer>
      <StyledCellText $textWidth={textWidth}>{value}</StyledCellText>
      <HtmlTooltip
        interactive
        placement={'bottom'}
        title={<div onClick={inhibitClick}>{tooltip}</div>}
        arrow
      >
        <StyledHelpOutlineRoundedIcon />
      </HtmlTooltip>
    </StyledCellContainer>
  );
}
